import { createAction, props } from '@ngrx/store';

import {
  PortalConfigDefinition,
  RoleType,
} from '@lockton-apps/shared/interfaces';

export const loadPortalConfigSuccess = createAction(
  '[PortalConfig API] Load PortalConfig Success',
  props<{ portalConfig: PortalConfigDefinition; role: RoleType }>()
);

export const loadPortalConfigFailure = createAction(
  '[PortalConfig API] Load PortalConfig Failure',
  props<{ error: any }>()
);

export const portalSelected = createAction(
  '[PortalConfig Page] Portal Selected',
  props<{ portalId: number }>()
);
